// extracted by mini-css-extract-plugin
module.exports = {"comparison":"Table_comparison__V9N_0","checked":"Table_checked__ih6za","unchecked":"Table_unchecked__94cje","footer":"Table_footer__zDkSN"};